import React, { useState, useContext } from "react";
import { Modal, Button, Card, Switch, Checkbox } from "antd";
import _axios from "../../utils/api/_axios";
import { toast } from "react-toastify";
import { baseUrl } from "../../common/constants";
import { mainContext } from "../../context/context";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const ValidateModal = ({
  open,
  handleClose,
  patientsList,
  selectedData,
  selectedClaim,
  patientId,
  setPatientID,
  message,
  docs,
  claimId
}) => {
  const { formDataValues, insurenceId, adjusterId } = useContext(mainContext);
  const [isToggle, setIsToggle] = useState(false);
  const [requestName, setRequestName] = useState("");
  const [selectedItemId, setSelectedItemId] = useState(null);
  const [checked, setChecked] = useState(false);
  const navigation = useNavigate();

  const handleCheckboxChange = (patientID) => {
    setSelectedItemId(patientID === selectedItemId ? null : patientID);
    setPatientID(patientID === selectedItemId ? null : patientID);
  };

  const handleMerge = async () => {
    if (requestName === "Merge" && patientId === null) {
      toast.error("Plesae Select Patient");
    } else {
      try {
        const response = await _axios.put(
          `${baseUrl}/patients/${patientId}`,
          formDataValues.patientInfo
        );
        
        if (response.status === 200) {
          handleUpdateClaimData();
          toast.success("Patient information updated successfully");
          handleClose();
          navigation('/new-entries')
        } else {
          toast.error("Failed to update patient information");
        }
      } catch (error) {
        console.error(error);
        toast.error("Failed to update patient.");
      }
    }
  };

  const handleUpdateClaimData = async () => {
    let claimId = selectedClaim._id;
    const updateProperties = {
      patientId: selectedClaim?._id,
      employerDetails: formDataValues.employeeInfo,
      adjusterInfo: {
        script:docs[0],
        adjusterType:
          formDataValues?.referredBy == "other"
            ? formDataValues?.referralInfoValue
            : formDataValues?.referredBy,
        adjusterId: adjusterId,
        insuranceCompanyId: insurenceId,
        referringDoctor: formDataValues.referredByInfo,
        insured: formDataValues.referredByInfo.referredByInfo,
      },
      procedures: formDataValues.proceduresInfo,
      specialInstructions: formDataValues.specialInstruction,
    };

    try {
      const response = await _axios.post(
        `${baseUrl}/openAccess/claims/${patientId}/${claimId}`,
        { updateProperties, patientInfo: formDataValues.patientInfo },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 201) {
        try {
          const response = await _axios.put(
            `${baseUrl}/openAccess/adminApproval/${selectedClaim?._id}`,
            { isAdminApproved: true },
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          );
        } catch (error) {
          toast.error(error);
        }
      } else {
        toast.error("Failed to update claim information");
      }
    } catch (error) {
      toast.error(error.response?.data?.metadata?.errorMessage);
    }
  };

  const handleCreateClaimData = async () => {
    formDataValues.referredByInfo["script"] = docs[0];
    const claimProperties = {
      employerDetails: formDataValues.employeeInfo,
      adjusterInfo: formDataValues.referredByInfo,
      procedures: formDataValues.proceduresInfo,
      specialInstructions: formDataValues.specialInstruction,
    };
    try {
      const response = await _axios.post(
        `${baseUrl}/openAccess/claims/${selectedClaim?._id}`,
        { ...claimProperties, patientInfo: formDataValues?.patientInfo },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 201) {
        toast.success("Claim created successfully");
        try {
          const response = await _axios.put(
            `${baseUrl}/openAccess/adminApproval/${selectedClaim?._id}`,
            { isAdminApproved: true },
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          );
        } catch (error) {
          toast.error(error);
        }
        handleClose();
        navigation('/new-entries')
      } else {
        toast.error("Failed to update claim information");
      }
    } catch (error) {
      toast.error(error.response?.data?.metadata?.errorMessage);
    }
  };

  return (
    <div>
      <Modal
        title={message}
        wrapClassName="vertical-center-modal"
        open={open}
        onOk={handleClose}
        onCancel={handleClose}
        footer={[
          <Button
            key="back"
            disabled={selectedItemId === null}
            onClick={() => {
              handleMerge();
              setRequestName("Merge");
            }}
          >
            Merge
          </Button>,
          <Button
            key="submit"
            type="primary"
            onClick={() => {
              handleCreateClaimData();
              setRequestName("Create");
            }}
          >
            Create New
          </Button>,
        ]}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            flexWrap: "wrap",
            gap: "10px",
          }}
        >
          {patientsList.patients?.map((ele) => (
            <Card style={{ marginTop: "10px" }} key={ele._id}>
              <Checkbox
                checked={selectedItemId === ele._id}
                onChange={() => handleCheckboxChange(ele._id)}
              />
              <span style={{ padding: "5px" }}>{ele.firstName}</span>
            </Card>
          ))}
        </div>
      </Modal>
    </div>
  );
};

export default ValidateModal;
